import React, {
  createContext,
  useContext,
  useState,
  type ReactNode,
} from 'react'

interface TokenSelectionContextType {
  selectedTokenIndex: number
  setSelectedTokenIndex: (index: number) => void
}

const TokenSelectionContext = createContext<
  TokenSelectionContextType | undefined
>(undefined)

export const useTokenSelection = () => {
  const context = useContext(TokenSelectionContext)
  if (context === undefined) {
    throw new Error(
      'useTokenSelection must be used within a TokenSelectionProvider'
    )
  }
  return context
}

interface TokenSelectionProviderProps {
  children: ReactNode
}

export const TokenSelectionProvider: React.FC<TokenSelectionProviderProps> = ({
  children,
}) => {
  const [selectedTokenIndex, setSelectedTokenIndex] = useState<number>(0)

  return (
    <TokenSelectionContext.Provider
      value={{ selectedTokenIndex, setSelectedTokenIndex }}
    >
      {children}
    </TokenSelectionContext.Provider>
  )
}
